import { render, staticRenderFns } from "./allocation.vue?vue&type=template&id=0cd58a69&scoped=true&"
import script from "./allocation.vue?vue&type=script&lang=js&"
export * from "./allocation.vue?vue&type=script&lang=js&"
import style0 from "./allocation.vue?vue&type=style&index=0&id=0cd58a69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd58a69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd58a69')) {
      api.createRecord('0cd58a69', component.options)
    } else {
      api.reload('0cd58a69', component.options)
    }
    module.hot.accept("./allocation.vue?vue&type=template&id=0cd58a69&scoped=true&", function () {
      api.rerender('0cd58a69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/allocation/allocation.vue"
export default component.exports